( function() {
    'use strict';

    let form = document.querySelector('.page-send-attachment-files-to-email');
    let btnSend;
    let btnSendCaption;
    let loading;

    init();

    /**
     * Инициализация
     *
     */
    function init() {
        if (!form) {
            return;
        }

        btnSend = form.querySelector('.js-btn-send');
        btnSendCaption = btnSend.querySelector('.js-btn-send-caption');
        loading = btnSend.querySelector('.js-loading');

        onFormInput();
        onButtonSendClick();
    }

    /**
     * Обработка клика по кнопке 'Отправить'
     *
     */
    function onButtonSendClick() {
        btnSend.addEventListener('click', function(evt) {
            evt.preventDefault();

            if (!form.checkValidity()) {
                btnSend.disabled = false;
                noty({
                    text: 'Введите Ваш электронный адрес!',
                    type: 'error',
                    timeout: 5000
                });
                return;
            }

            send();

        });
    }

    function send() {
        var formData = new FormData(form);
        var request = new XMLHttpRequest();

        request.open('POST', form.getAttribute('data-action'), true);
        request.onreadystatechange = function() {
            if (request.readyState != 4) {
                return;
            }

            processingResponse(request);
        };

        request.send(formData);

        btnSend.disabled = true;
        btnSendCaption.classList.add('hidden');
        loading.classList.remove('hidden');
    }

    function processingResponse(request) {
        let responseText = request.responseText;

        btnSend.disabled = false;
        btnSendCaption.classList.remove('hidden');
        loading.classList.add('hidden');

        if ((request.status !== 200) || !responseText) {
            responseText = '{"result":"error","message":""}';
        }

        let response = JSON.parse(responseText);
        if (!response.result || (response.result !== 'ok')) {
            noty({
                text: response.message || 'Ошибка!',
                type: 'error'
            });
            return;
        }

        form.elements.email.value = '';
        btnSend.disabled = true;

        noty({
            text: 'Файлы успешно отправлены на Ваш электронный адрес!',
            type: 'success'
        });

        window.GAEvent.send({
            eventCategory: 'Прикреплённые файлы',
            eventAction: 'Отправлено на почту',
            eventLabel: btnSend.getAttribute('data-ga-event-label')
        });
    }

    /**
     * Обработка ввода данных в поля формы
     *
     */
    function onFormInput() {
        form.addEventListener('input', function() {

            btnSend.disabled = !form.checkValidity();

        });
    }

}());

